export const containerUnits = [
  {
    label: 'Mililitres',
    value: 'mililitres',
    suffix: 'mL',
  },
  {
    label: 'Litres',
    value: 'litres',
    suffix: 'L',
  },
  {
    label: 'Grams',
    value: 'grams',
    suffix: 'g',
  },
  {
    label: 'Kilograms',
    value: 'kilograms',
    suffix: 'Kg',
  },
  {
    label: 'Units',
    value: 'units',
    suffix: '',
  },
];

/**
 * Resolve the short-form unit suffix (mL / L / g / Kg) for an asset's
 * container_unit value. Falls back to the raw value for unrecognised units
 * (including 'other' where the operator has typed a custom label).
 *
 * @param {string} value Container unit value (e.g. 'litres')
 * @param {string} [fallback] Optional fallback (e.g. asset.other_container_unit)
 * @returns {string}
 */
export const getContainerUnitSuffix = (value, fallback = '') => {
  const match = containerUnits.find(u => u.value === value);
  if (match) return match.suffix;
  return fallback;
};
